mmf_modules.define('api/userTOSAcceptance',['require','exports','module','jquery'],function (require, exports, module) {

  var $ = require('jquery');

  exports.get = function (userId) {
    return $.getJSON('/vxproxy/api/0.1/user_tos_acceptance/' + userId + '/');
  };

  exports.update = function (userId, tos) {
    var selfLink;
    try {
      selfLink = tos._embedded.tos[0]._links.self;
    } catch (e) {
      return $.Deferred().reject(e);
    }
    return $.ajax({
      url: '/vxproxy/api/0.1/user_tos_acceptance/' + userId + '/',
      method: 'put',
      data: JSON.stringify({
        _links: {
          tos: selfLink,
          user: [{
            href: '/v7.1/user/' + userId + '/',
            id: userId
          }]
        }
      })
    });
  };

});

